import { FeatureId, FeatureState } from './enums';

/**
 * В ShbDeployer понятие редакции продукта не используется: все функции доступны
 * без ограничений. Модуль сохранён как точка расширения и для совместимости
 * сигнатур вызывающего кода — ни одна функция не скрывается и не блокируется.
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function selectShow(featureId?: FeatureId): FeatureState {
  // Параметр сохранён для совместимости сигнатуры вызывающего кода.
  return FeatureState.VISIBLE;
}

export function isLimitedToBE(featureId?: FeatureId) {
  return selectShow(featureId) === FeatureState.LIMITED_BE;
}
